export const fmtNOK = (n) =>
  new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK", maximumFractionDigits: 0 }).format(n || 0);

export const fmtNum = (n) => new Intl.NumberFormat("nb-NO").format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("nb-NO", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const CUSTOMER_STATUS = {
  lead: { label: "Lead", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  prospekt: { label: "Prospekt", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  onboarding: { label: "Onboarding", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  intern_godkjenning: { label: "Intern godkjenning", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  klar_signering: { label: "Klar for signering", cls: "bg-violet-500/15 text-violet-400 border-violet-500/30" },
  aktiv: { label: "Aktiv kunde", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  pa_vent: { label: "På vent", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30" },
  forhoyet_risiko: { label: "Forhøyet risiko", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  under_avslutning: { label: "Under avslutning", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30" },
  avsluttet: { label: "Avsluttet", cls: "bg-zinc-600/15 text-zinc-500 border-zinc-600/30" },
  avvist: { label: "Avvist", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};

export const KYC_STATUS = {
  ikke_pabegynt: "Ikke påbegynt", invitert: "Invitert", under_utfylling: "Under utfylling",
  innsendt: "Innsendt", mangler_info: "Mangler informasjon", under_kontroll: "Under kontroll",
  forsterkede_tiltak: "Forsterkede tiltak", ledelsesgodkjenning: "Til ledelsesgodkjenning",
  godkjent: "Godkjent", avvist: "Avvist", utlopt: "Utløpt", ny_kontroll: "Ny kontroll kreves",
};

export const RISK = {
  lav: { label: "Lav", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  normal: { label: "Normal", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  forhoyet: { label: "Forhøyet", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  hoy: { label: "Høy", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30" },
  uakseptabel: { label: "Uakseptabel", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};

export const STAGE_LABELS = {
  nytt_lead: "Nytt lead", kontaktet: "Kontaktet", mote_avtalt: "Møte avtalt",
  behov_kartlagt: "Behov kartlagt", tilbud_sendt: "Tilbud sendt", tilbud_akseptert: "Tilbud akseptert",
  kyc_sendt: "KYC sendt", kyc_behandling: "KYC under behandling", intern_godkjenning: "Intern godkjenning",
  avtale_sendt: "Avtale sendt", signert: "Signert", vunnet: "Vunnet", tapt: "Tapt",
};

export const SIGN_STATUS = {
  ikke_opprettet: "Ikke opprettet", kladd: "Kladd", klar: "Klar", sendt: "Sendt",
  levert: "Levert", apnet: "Åpnet", delvis_signert: "Delvis signert", fullfort: "Fullført",
  venter_motsignatur: "Venter på oppdragsansvarlig", venter_kunde: "Venter på kunde",
  venter_ansatt: "Venter på ansatt", signert: "Signert",
  avvist: "Avvist", utgatt: "Utgått", kansellert: "Kansellert", feilet: "Feilet",
};

export const BILLING = {
  manedlig: "Månedlig", kvartalsvis: "Kvartalsvis", halvarlig: "Halvårlig",
  arlig: "Årlig", engangs: "Engangs",
};

export const ROLE_LABELS = {
  admin: "Administrator", management: "Daglig leder", engagement_manager: "Oppdragsansvarlig",
  kyc_officer: "KYC-ansvarlig", accountant: "Regnskapsmedarbeider", sales: "Salgsmedarbeider",
};

// Faktureringsavrunding for stoppeklokke:
// 0–1 min => 0, over 1 t.o.m. 6 min => 6 min (0,1 t),
// over 6 min => rundes opp til nærmeste 15 min (0,25 t). F.eks. 9 min => 15, 24 min => 30.
export function billedHoursFromSeconds(secs) {
  const mins = (secs || 0) / 60;
  let m;
  if (mins <= 1) m = 0;
  else if (mins <= 6) m = 6;
  else m = Math.ceil(mins / 15) * 15;
  return Math.round((m / 60) * 100) / 100;
}
